import FooterSection from 'assets/Footer';
import Navbar from '../assets/Navbar';
import CardDesign from '../components/cardDesign';
import useAllFreeDeliveryProducts from 'hook/useAllFreeDeliveryProducts';
import CardShimmer from "../components/shimmer/CardShimmer";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
const FreeDeliveryFullPage = () => {
    const { allFreeDeliveryProducts, loading1, error } = useAllFreeDeliveryProducts();

    if (loading1) {
        return (
            <div className='bg-gray-100 flex flex-col min-h-[100dvh]'>
                <CardShimmer count={8} />
            </div>
        );
    }
    return (
        <div className='bg-gray-100 flex flex-col min-h-[100dvh]'>
            <Navbar />
            <div className="container mx-auto relative">
                {loading1 && (
                    <div className="flex justify-center items-center h-[50vh]">
                        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#7209B7]" />
                    </div>
                )}


                {/* ✅ Data */}
                {!loading1 && !error && allFreeDeliveryProducts.length > 0 && (
                    <div className='mb-3'>
                        <div className="flex items-center justify-center w-full px-4 md:my-5 my-3">
                            <span className="md:text-2xl text-xl md:font-bold font-extrabold text-black tracking-wide pt-3 pb-1">
                                FREE DELIVERY OFFER PRODUCTS
                            </span>
                        </div>
                        <CardDesign likeData={allFreeDeliveryProducts} />
                    </div>
                )}
            </div>
            <FooterSection />
            <ScreenScrollToTop />
        </div>
    );
};

export default FreeDeliveryFullPage;